export default "__VITE_ASSET__DxNoNhKU__"